import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";

export type ManualAssessmentReassignDialogProps = Readonly<{
  open: boolean;
  submitting?: boolean;
  onClose: () => void;
  onConfirm: (userId: string) => void | Promise<void>;
}>;

export default function ManualAssessmentReassignDialog({
  open,
  submitting = false,
  onClose,
  onConfirm,
}: ManualAssessmentReassignDialogProps) {
  const [userId, setUserId] = useState("");

  const handleClose = () => {
    if (submitting) return;
    setUserId("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>Reassign Task</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="New assignee user ID"
          fullWidth
          value={userId}
          disabled={submitting}
          onChange={(event) => setUserId(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={submitting}>
          Cancel
        </Button>
        <Button
          variant="contained"
          disabled={submitting || !userId.trim()}
          onClick={() => void onConfirm(userId.trim())}
        >
          Reassign
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export function isTaskReassignable(
  propertyValueItemList: Array<{ field?: string; fieldValue?: unknown; default?: unknown }> | undefined,
): boolean {
  const item = propertyValueItemList?.find((row) => row.field === "reassignable");
  if (!item) return false;
  const value = item.fieldValue ?? item.default;
  return value === true || String(value).toLowerCase() === "true";
}
